export const ANUAL = 1;
export const MENSUAL = 2;
export const BIENAL = 3;
export const TRIENAL = 4;
export const CUATRIENAL = 5;

export const tiposDeCuota = [
  { id: CUATRIENAL, nombre: "Pago único 48 Meses", meses: 48 },
  { id: TRIENAL, nombre: "Pago único 36 Meses", meses: 36 },
  { id: BIENAL, nombre: "Pago único 24 Meses", meses: 24 },
  { id: ANUAL, nombre: "Pago único 12 Meses", meses: 12 },
  { id: MENSUAL, nombre: "Pago Mensual", meses: 1 },
];

export const mapaNombresCuota = {
  [CUATRIENAL]: "Pago único 48 Meses",
  [TRIENAL]: "Pago único 36 Meses",
  [BIENAL]: "Pago único 24 Meses",
  [ANUAL]: "Pago único 12 Meses",
  [MENSUAL]: "Pago Mensual",
};

export const comboTiposDeCuota = tiposDeCuota.map((tc) => {
  return {
    text: tc.nombre,
    value: tc.id,
  };
});

export const nombreTipoCuota = function (tipo) {
  return mapaNombresCuota[tipo];
};
